export enum SlotAdditionalClassName {
  TOP = 'top',
  MIDDLE = 'middle',
  BOTTOM = 'bottom'
}
